export const useProgress = () => {
  const getProgress = (items, checkedItems) => {
    if (!items || items.length === 0) return 0;
    const checkedCount = items.filter(item => checkedItems.has(item.id)).length;
    return Math.round((checkedCount / items.length) * 100);
  };

  return { getProgress };
};